import { render, staticRenderFns } from "./desc_section.vue?vue&type=template&id=41a49790&scoped=true&"
import script from "./desc_section.vue?vue&type=script&lang=js&"
export * from "./desc_section.vue?vue&type=script&lang=js&"
import style0 from "./desc_section.vue?vue&type=style&index=0&id=41a49790&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a49790",
  null
  
)

export default component.exports